<div
	class="lu-select"
	[ngClass]="{ 'is-disabled': options.disabled }"
	[id]="options.id"
	[attr.aria-label]="
		options.disabled || options.readonly
			? ('lup.a11y.select.guidance_disabled' | translate)
			: ('lup.a11y.select.guidance' | translate)
	">
	<span
		class="sr-only"
		[attr.aria-live]="liveAnnouncer ? 'assertive' : 'off'"
		aria-atomic="true"
		[attr.aria-label]="liveAnnouncer">
	</span>

	<div
		tabindex="{{ options.disabled ? -1 : 0 }}"
		(click)="toggleList()"
		class="lu-select__control"
		[attr.aria-disabled]="options.disabled">
		<div
			[attr.readonly]="options.readonly ? 'true' : undefined"
			[ngClass]="{ 'lu-select__control--is-focused': isOpen }"
			class="lu-select__text"
			*ngIf="!!selectedItem; else placeholderText">
			<lu-select-item-wrapper [selectedItem]="true" [options]="options?.itemOptions" [data]="selectedItem">
			</lu-select-item-wrapper>
		</div>

		<ng-template #placeholderText>
			<div [ngClass]="{ 'is-invalid': !isValid() }" [attr.disabled]="options.disabled" class="lu-select__text">
				{{ placeholder | translate }}
			</div>
		</ng-template>

		<div *ngIf="!options.readonly && !options.disabled" class="o-flex">
			<lu-icon
				id="clearButtonIcon"
				(click)="clearSelection($event)"
				role="button"
				[attr.aria-label]="'lup.a11y.select.clear_selected_item_label' | translate"
				tabindex="0"
				[type]="LuIconType.REGULAR"
				icon="lu-clear"
				*ngIf="options.displayClearButton && !!selectedItem"></lu-icon>

			<lu-icon
				[type]="LuIconType.REGULAR"
				icon="lu-chevron-down"
				[ngClass]="{ 'fa-rotate-180': isOpen }"
				*ngIf="!(options.displayClearButton && !!selectedItem)"></lu-icon>
		</div>
	</div>

	<div class="lu-select__ddm" [ngClass]="{ 'lu-select__ddm--is-open': isOpen, 'lu-select__ddm--is-open-up': isDDMUp }">
		@if (showSearch) {
			<div class="lu-select__ddm__search">
				<lu-search
					[value]="searchValue"
					(valueChange)="inputChange$.next({ value: $event.value, key: $event.event['key'] })"
					(clearSearch)="clearSearch()"
					[searchOptions]="searchOptions"
					(inputClicked)="setCursor()">
				</lu-search>
			</div>
		}
		<ul
			luInfiniteScroll
			[scrollPercent]="scrollDistance"
			[debounceTime]="debounceTime"
			(scrolled)="onScrollDown()"
			#itemsBox>
			<ng-container *ngIf="items$ | async as itemsList">
				<ng-container *ngIf="itemsList.length > 0; else empty">
					<ng-container *ngIf="!!groupBy; else classicList">
						<div
							*ngFor="let group of itemsList | groupBy: groupBy; let i = index"
							aria-atomic="true"
							[attr.aria-live]="isActive(group, i) ? 'polite' : 'off'">
							<div class="lu-select__group-label">{{ group.key }}</div>
							<li
								class="lu-select__item"
								role="option"
								*ngFor="let item of group.value; let i = index; trackBy: trackByFn"
								(click)="selectItem(item)"
								[ngClass]="{ 'lu-select__item--active': isGroupItemActive(item) }"
								aria-atomic="true"
								[attr.aria-live]="isGroupItemActive(item) ? 'polite' : 'off'"
								(mouseenter)="onGroupItemHover(item)"
								#singleItemEl>
								<lu-select-item-wrapper [options]="options?.itemOptions" [data]="item"> </lu-select-item-wrapper>
							</li>
						</div>
					</ng-container>

					<ng-template #classicList>
						<li
							class="lu-select__item"
							role="option"
							*ngFor="let item of itemsList; let i = index; trackBy: trackByFn"
							(click)="selectItem(item)"
							[ngClass]="{ 'lu-select__item--active': isActive(item, i) }"
							aria-atomic="true"
							[attr.aria-live]="isActive(item, i) ? 'polite' : 'off'"
							(mouseenter)="onHover(i)"
							#singleItemEl>
							<lu-select-item-wrapper [options]="options?.itemOptions" [data]="item"> </lu-select-item-wrapper>
						</li>
					</ng-template>
				</ng-container>
			</ng-container>
			<ng-template #empty>
				<div class="lu-select__empty_state">
					<div class="lu-select__empty_state__icon">
						<lu-icon class="lui" icon="search"></lu-icon>
					</div>
					<ng-container *ngIf="originalItems.length; else noData">
						<div class="lu-select__empty_state__title">{{ 'lup.select.no_results_found' | translate }}</div>
					</ng-container>
					<ng-template #noData>
						<div class="lu-select__empty_state__title">
							{{ options.noDataFound || 'lup.select.no_data_to_display' | translate }}
						</div>
					</ng-template>
				</div>
			</ng-template>
		</ul>
		<ng-content></ng-content>
	</div>
</div>
